module.exports = __webpack_public_path__ + "b4fa1b8cfcde40c8d334de072f9a4180.png";